/* Progressive enhancement for the unpublished product section. Native Shopify owns purchases. */
if (!customElements.get('wl-product-tools')) {
  customElements.define('wl-product-tools', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root) return;
      this.expanded = new Set();
      this.bar = this.querySelector('.wl-product-sticky');
      this.onClick = (event) => {
        const toggle = event.target.closest('[data-wl-toggle]');
        if (toggle && this.root.contains(toggle)) {
          const field = toggle.closest('fieldset');
          const key = field.dataset.wlOption;
          if (this.expanded.has(key)) this.expanded.delete(key); else this.expanded.add(key);
          this.refreshColors(field);
        }
        if (event.target.closest('[data-wl-return]')) {
          const target = this.root.querySelector('variant-selects') || this.root.querySelector('product-form');
          if (!target) return;
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          const focus = target.querySelector('input:checked, select, button[name="add"]');
          focus?.focus({ preventScroll: true });
        }
      };
      this.root.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.refresh());
      });
      this.observer.observe(this.root, { childList: true, subtree: true });
      const gallery = this.root.querySelector('media-gallery');
      if (gallery) {
        this.galleryObserver = new MutationObserver(() => this.refreshThumbnails());
        this.galleryObserver.observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden', 'class'] });
      }
      this.refresh();
      const main = this.root.querySelector('button[name="add"]');
      if (main && this.bar) {
        this.intersection = new IntersectionObserver(([entry]) => {
          // Only show after the primary purchase area has been passed.
          this.bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        });
        this.intersection.observe(main);
      }
    }
    refreshColors(field) {
      const radios = Array.from(field.querySelectorAll('input[type="radio"]'));
      if (radios.length <= 8) return;
      const open = this.expanded.has(field.dataset.wlOption);
      radios.forEach((radio, index) => {
        const hidden = !open && index >= 8 && !radio.checked;
        radio.classList.toggle('wl-hidden-choice', hidden);
        radio.labels.forEach(label => label.classList.toggle('wl-hidden-choice', hidden));
      });
      let toggle = field.querySelector('[data-wl-toggle]');
      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'link wl-color-toggle';
        toggle.dataset.wlToggle = '';
        field.append(toggle);
      }
      toggle.setAttribute('aria-expanded', String(open));
      const text = open ? this.dataset.hideColors : `${this.dataset.showColors} (${radios.length})`;
      if (toggle.textContent !== text) toggle.textContent = text;
    }
    refresh() {
      this.refreshThumbnails();
      this.root.querySelectorAll('fieldset[data-wl-option]').forEach(field => {
        if (/^(color|colour)$/i.test(field.dataset.wlOption)) this.refreshColors(field);
      });
      const price = this.root.querySelector('[id^="price-"] .price');
      const amount = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
      const output = this.querySelector('[data-wl-price]');
      if (output && amount && output.textContent !== amount.textContent.trim()) output.textContent = amount.textContent.trim();
    }
    disconnectedCallback() {
      this.root?.removeEventListener('click', this.onClick);
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.galleryObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    refreshThumbnails() {
      const slider = this.root.querySelector('.thumbnail-slider');
      if (!slider) return;
      const visible = Array.from(slider.querySelectorAll('.thumbnail-list__item')).filter(item => !item.hidden && getComputedStyle(item).display !== 'none');
      const centered = visible.length > 0 && visible.length < 5;
      if (slider.classList.contains('wl-thumbnails-centered') !== centered) {
        slider.classList.toggle('wl-thumbnails-centered', centered);
        if (centered) slider.querySelector('.thumbnail-list')?.scrollTo({left: 0});
      }
    }
  });
}


document.addEventListener('click',function(event){
 const link=event.target.closest('.wl-material-summary__value');
 if(!link)return;
 const target=document.getElementById(link.hash.slice(1));
 if(!target)return;
 event.preventDefault();
 target.open=true;
 target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
 target.querySelector('summary').focus({preventScroll:true});
});
